module.exports = delay => new Promise( resolve => setTimeout( resolve, delay ) );


// WEBPACK FOOTER //
// ./js/utils/wait.js